var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-col",
    { staticClass: "pa-0", attrs: { cols: "12" } },
    [
      _c(
        "v-row",
        _vm._l(_vm.list, function (d, index) {
          return _c(
            "v-col",
            {
              key: `${d.cpos_id}-${index}`,
              attrs: {
                cols: "4",
                md: _vm.$vuetify.breakpoint.width < 1200 ? 3 : 2,
              },
            },
            [
              _c("v-hover", {
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ hover }) {
                        return [
                          _c(
                            "v-card",
                            {
                              staticClass: "pa-5 rounded-md",
                              attrs: { elevation: hover ? 5 : 0, flat: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.goTo(d.cpos_id)
                                },
                              },
                            },
                            [
                              _c(
                                "v-row",
                                { attrs: { "no-gutters": "" } },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "grey-900" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$route.name === "BranchListCreate"
                                            ? "mdi-store"
                                            : "mdi-printer-pos"
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("v-spacer"),
                                ],
                                1
                              ),
                              _c("span", { staticClass: "d-block pt-2" }, [
                                d.name
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "grey-500--text font-weight-medium body-1 d-inline-block text-truncate",
                                        staticStyle: { "max-width": "160px" },
                                      },
                                      [_vm._v(_vm._s(d.name))]
                                    )
                                  : _c(
                                      "span",
                                      {
                                        staticClass:
                                          "d-block body-2 text--disabled font-italic mb-3",
                                      },
                                      [_vm._v("Sin especificar")]
                                    ),
                              ]),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "d-block body-2 mt-n2 grey-300--text d-inline-block text-truncate",
                                  staticStyle: {
                                    "max-width": "160px",
                                    "line-height": "22px",
                                  },
                                },
                                [[_vm._v(_vm._s(d.branch_id))]],
                                2
                              ),
                              [
                                "PosListCreate",
                                "PosGroupsRetrieveUpdate",
                              ].includes(_vm.$route.name)
                                ? _c(
                                    "span",
                                    { staticClass: "d-block mb-2 mt-3 body-2" },
                                    [
                                      d
                                        ? _c(
                                            "v-chip",
                                            {
                                              attrs: {
                                                color: d.active
                                                  ? "lightBlue"
                                                  : "",
                                                small: "",
                                                label: "",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  d.active
                                                    ? "Activo"
                                                    : "Inactivo"
                                                )
                                              ),
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    right: "",
                                                    size: "18",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "mdi-cloud" +
                                                      _vm._s(
                                                        d.active ? "" : "-off"
                                                      )
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }